const formatDateTime = (value) => {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return '-';
  }
};

const AdminUsersTable = ({
  users,
  loading,
  onEdit,
  onToggleStatus,
  onResetPassword,
  onDelete,
}) => {
  return (
    <div className="overflow-x-auto rounded-[28px] border border-[color:var(--admin-border)] bg-white shadow-sm">
      <table className="min-w-full text-sm">
        <thead className="border-b border-[color:var(--admin-border)] text-xs uppercase tracking-[0.24em] text-[color:var(--admin-icon)]">
          <tr>
            <th className="px-4 py-4 text-left">Name</th>
            <th className="px-4 py-4 text-left">Email</th>
            <th className="px-4 py-4 text-left">Type</th>
            <th className="px-4 py-4 text-left">Assigned roles</th>
            <th className="px-4 py-4 text-left">Status</th>
            <th className="px-4 py-4 text-left">Last login</th>
            <th className="px-4 py-4 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <td colSpan="7" className="px-4 py-8 text-center text-[color:var(--admin-text)]">
                Loading admins...
              </td>
            </tr>
          )}
          {!loading && !users.length && (
            <tr>
              <td colSpan="7" className="px-4 py-8 text-center text-[color:var(--admin-text)]">
                No admin users found.
              </td>
            </tr>
          )}
          {users.map((user) => (
            <tr key={user.id} className="border-b border-[color:var(--admin-border)] last:border-b-0">
              <td className="px-4 py-4">
                <div className="font-semibold text-[color:var(--admin-heading)]">{user.fullName}</div>
                <div className="text-xs text-[color:var(--admin-text)]">
                  {user.mustChangePassword ? 'Password reset pending' : 'Password active'}
                </div>
              </td>
              <td className="px-4 py-4 text-[color:var(--admin-text)]">{user.email}</td>
              <td className="px-4 py-4">
                <span className={`rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${user.adminType === 'MASTER_ADMIN' ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-600'}`}>
                  {user.adminType}
                </span>
              </td>
              <td className="px-4 py-4">
                <div className="flex flex-wrap gap-2">
                  {user.roles?.length ? (
                    user.roles.map((role) => (
                      <span
                        key={role.id}
                        className="rounded-full border border-[color:var(--admin-border)] bg-[var(--admin-muted-surface)] px-3 py-1 text-xs text-[color:var(--admin-heading)]"
                      >
                        {role.roleName}
                      </span>
                    ))
                  ) : (
                    <span className="text-[color:var(--admin-text)]">-</span>
                  )}
                </div>
              </td>
              <td className="px-4 py-4">
                <span className={`rounded-full px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${user.isActive ? 'bg-emerald-50 text-emerald-700' : 'bg-rose-50 text-rose-600'}`}>
                  {user.isActive ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td className="px-4 py-4 text-[color:var(--admin-text)]">{formatDateTime(user.lastLoginAt)}</td>
              <td className="px-4 py-4">
                <div className="flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={() => onEdit(user)}
                    className="rounded-full border border-[color:var(--admin-border)] px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--admin-heading)]"
                  >
                    Edit / Assign
                  </button>
                  <button
                    type="button"
                    onClick={() => onToggleStatus(user)}
                    className="rounded-full border border-[color:var(--admin-border)] px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--admin-heading)]"
                  >
                    {user.isActive ? 'Deactivate' : 'Activate'}
                  </button>
                  <button
                    type="button"
                    onClick={() => onResetPassword(user)}
                    className="rounded-full border border-[color:var(--admin-border)] px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--admin-heading)]"
                  >
                    Reset Password
                  </button>
                  {user.adminType !== 'MASTER_ADMIN' && (
                    <button
                      type="button"
                      onClick={() => onDelete(user)}
                      className="rounded-full border border-rose-200 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-rose-600"
                    >
                      Delete
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminUsersTable;
